/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ListOperators } from '../models/ListOperators';

export class SubnetsCondition {
  'operator': ListOperators;
  'subnets': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "ListOperators",
      "format": ""
    },
    {
      "name": "subnets",
      "baseName": "subnets",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SubnetsCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



